<h2 mat-dialog-title>{{ data?.title || 'Scan to Upload' }}</h2>
<mat-dialog-content class="upload-dialog-content">
    <p class="info-text" *ngIf="data?.description">
        {{ data.description }}
    </p>
    <div class="qr-container" *ngIf="qrCodeDataUrl; else loading">
        <div class="qrcodeImage">
            <qrcode [qrdata]="qrCodeDataUrl"
                [ariaLabel]="'QR code for uploading a document by scanning this code using a mobile device.'"
                [cssClass]="'center'" [colorDark]="'#000000ff'" [colorLight]="'#ffffffff'" [elementType]="'canvas'"
                [errorCorrectionLevel]="'M'" [margin]="4" [scale]="1" [width]="300"></qrcode>
        </div>
        <p class="info-text">Scan this QR code to upload a document</p>
        <p class="info-text" *ngIf="expiryTimeFormatted">
            <em>Note: This QR code will expire at {{ expiryTimeFormatted }}.</em>
        </p>
    </div>
    <ng-template #loading>
        <p>Generating QR code...</p>
    </ng-template>

    <!-- Uploaded Documents -->
    <div *ngIf="uploadedDocuments.length" class="upload-section">
        <h3 class="section-title">
            <mat-icon color="primary">check_circle</mat-icon>
            Uploaded Documents
        </h3>
        <mat-list>
            <mat-list-item *ngFor="let doc of uploadedDocuments">
                <mat-icon matListIcon color="primary">description</mat-icon>
                <div mat-line>{{ doc.title || 'Untitled Document' }}</div>
                <div mat-line class="meta">Uploaded at: {{ doc.date | date: 'medium' }}</div>
                <a mat-icon-button [href]="doc.url" target="_blank" matTooltip="View Document">
                    <mat-icon>open_in_new</mat-icon>
                </a>
            </mat-list-item>
        </mat-list>
    </div>

    <!-- Failed Uploads -->
    <div *ngIf="failedUploads.length" class="upload-section failure">
        <h3 class="section-title">
            <mat-icon color="warn">error</mat-icon>
            Failed Uploads
        </h3>
        <mat-list>
            <mat-list-item *ngFor="let fail of failedUploads">
                <mat-icon matListIcon color="warn">warning</mat-icon>
                <div mat-line class="error-text">{{ fail.message || 'Unknown error' }}</div>
                <div mat-line class="meta">Attempted at: {{ fail.timestamp | date: 'medium' }}</div>
            </mat-list-item>
        </mat-list>
    </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
    <ng-container *ngIf="data?.actionButtonConfig?.show && data?.actionButtonConfig?.onClick">
        <button mat-flat-button color="primary" (click)="handleCustomAction()"
            [disabled]="uploadedDocuments.length === 0">
            {{ data.actionButtonConfig.label }}
        </button>
    </ng-container>

</mat-dialog-actions>